import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CAL_DEMO_BOOKING_URL } from '@app/config';
import { environment } from '@env/environment';
import { TuiButton } from '@taiga-ui/core';
import { TuiBadge } from '@taiga-ui/kit';
import { RoughNotationModule } from 'ng-rough-notation';

@Component({
  selector: 'app-compare-ionic-appflow-hero-section',
  imports: [RoughNotationModule, TuiBadge, TuiButton],
  templateUrl: './compare-ionic-appflow-hero-section.component.html',
  styleUrl: './compare-ionic-appflow-hero-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompareIonicAppflowHeroSectionComponent {
  protected readonly bookingUrl = CAL_DEMO_BOOKING_URL;
  protected readonly consoleBaseUrl = environment.consoleBaseUrl;
}
